
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/blog/strona/[page]",
      function () {
        return require("private-next-pages/en/blog/strona/[page].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/blog/strona/[page]"])
      });
    }
  